import MDXComponents from "@theme-original/MDXComponents";
import DocCardList from "@theme/DocCardList";
import {
  CustomBeforeSection,
  CustomAfterSection,
  IPA,
  Transliterator,
  TransliteratorElement,
} from "@site/src/components";
import MDPronunciation1 from "@site/src/markdown/pronunciation-of-the-alphabet";
import MDPronunciation2 from "@site/src/markdown/etymological-alphabet-extensions";
import MDNouns1 from "@site/src/markdown/nouns/endings";
import MDNouns2 from "@site/src/markdown/nouns/masculine";
import MDNouns3 from "@site/src/markdown/nouns/neuter";
import MDNouns4 from "@site/src/markdown/nouns/feminine";
import MDNouns5 from "@site/src/markdown/nouns/athematic";
import MDAdjectives1 from "@site/src/markdown/adjectives/basicEndings";
import MDAdjectives2 from "@site/src/markdown/adjectives/hard";
import MDAdjectives3 from "@site/src/markdown/adjectives/soft";
import MDPronouns1 from "@site/src/markdown/pronouns/personal";
import MDPronouns2 from "@site/src/markdown/pronouns/posessive";
import MDPronouns3 from "@site/src/markdown/pronouns/demonstrative";
import MDPronouns4 from "@site/src/markdown/pronouns/interrogative";
import MDPronouns5 from "@site/src/markdown/pronouns/indefinite";
import MDPronouns6 from "@site/src/markdown/pronouns/pronominal";
import MDNumeralsCardinals from "@site/src/markdown/numerals/0-900";
import MDNumerals1 from "@site/src/markdown/numerals/2-4";
import MDNumerals2 from "@site/src/markdown/numerals/5-30";
import MDNumeralsConverter from "@site/src/markdown/numerals/converter";
import MDVerbs1 from "@site/src/markdown/verbs/motion";
import MDVerbs2 from "@site/src/markdown/verbs/presentTense";
import MDVerbs3 from "@site/src/markdown/verbs/pastTense";
import MDVerbs4 from "@site/src/markdown/verbs/simplePastTense";
import MDVerbs5 from "@site/src/markdown/verbs/futureTense";
import MDVerbs6 from "@site/src/markdown/verbs/conditional";
import MDVerbs7 from "@site/src/markdown/verbs/imperative";
import MDVerbs8 from "@site/src/markdown/verbs/participlesAndGerund";
import MDVerbs9 from "@site/src/markdown/verbs/byti1";
import MDVerbs10 from "@site/src/markdown/verbs/byti2";
import MDVerbs11 from "@site/src/markdown/verbs/irregularExamples";
import MDPhonology1 from "@site/src/markdown/phonology/phonology-ipa";
import MDPhonology2 from "@site/src/markdown/phonology/consonants";
import MDPhonology3 from "@site/src/markdown/phonology/phonologyOverview";
import MDDerivation from "@site/src/markdown/derivation/commonSlavicSounds";
import MDFlavourisation1 from "@site/src/markdown/flavourisation/northAndSouth";
import MDFlavourisation2 from "@site/src/markdown/flavourisation/spelling1";
import MDFlavourisation3 from "@site/src/markdown/flavourisation/spelling2";
import MDSlovianto1 from "@site/src/markdown/simpleGrammar/phonology";
import MDSlovianto2 from "@site/src/markdown/simpleGrammar/dialogue";
import MDSlovianto3 from "@site/src/markdown/simpleGrammar/basicVocabulary.md";
import MDSimpleGrammar1 from "@site/src/markdown/simpleGrammar/presentTense";
import MDSimpleGrammar2 from "@site/src/markdown/simpleGrammar/pastTense";
import MDSimpleGrammar3 from "@site/src/markdown/simpleGrammar/imperative";
import MDSimpleGrammar4 from "@site/src/markdown/simpleGrammar/toBe";
import MDSimpleGrammar5 from "@site/src/markdown/simpleGrammar/nase-selo";
import MDPersonalPronouns1 from "@site/src/markdown/personalPronouns/firstPersSing";
import MDPersonalPronouns2 from "@site/src/markdown/personalPronouns/secondPersSing";
import MDPersonalPronouns3 from "@site/src/markdown/personalPronouns/thirdPersSingMascNeuter";
import MDPersonalPronouns4 from "@site/src/markdown/personalPronouns/thirdPersSingFem";
import MDPersonalPronouns5 from "@site/src/markdown/personalPronouns/firstPersPlural";
import MDPersonalPronouns6 from "@site/src/markdown/personalPronouns/secondPersPlural";
import MDPersonalPronouns7 from "@site/src/markdown/personalPronouns/thirdPersPlural";
import MDNumbers1 from "@site/src/markdown/numbers-1-10/numbers";
import MDOrthography1 from "@site/src/markdown/orthography/latin-alphabet.mdx";
import MDOrthography2 from "@site/src/markdown/orthography/cyrillic-alphabet.mdx";
import MDOrthography3 from "@site/src/markdown/orthography/disappeared-phonemes.mdx";
import MDOrthography4 from "@site/src/markdown/orthography/alphabetOverview";
import IntelligibilityBuilder from "@site/src/components/IntelligibilityBuilder/IntelligibilityBuilder";

export default {
  ...MDXComponents,
  CustomAfterSection,
  CustomBeforeSection,
  DocCardList,
  IPA,
  IntelligibilityBuilder,
  MDPronunciation1,
  MDPronunciation2,
  MDNouns1,
  MDNouns2,
  MDNouns3,
  MDNouns4,
  MDNouns5,
  MDAdjectives1,
  MDAdjectives2,
  MDAdjectives3,
  MDPronouns1,
  MDPronouns2,
  MDPronouns3,
  MDPronouns4,
  MDPronouns5,
  MDPronouns6,
  MDNumeralsCardinals,
  MDNumerals1,
  MDNumerals2,
  MDNumeralsConverter,
  MDVerbs1,
  MDVerbs2,
  MDVerbs3,
  MDVerbs4,
  MDVerbs5,
  MDVerbs6,
  MDVerbs7,
  MDVerbs8,
  MDVerbs9,
  MDVerbs10,
  MDVerbs11,
  MDPhonology1,
  MDPhonology2,
  MDPhonology3,
  MDDerivation,
  MDFlavourisation1,
  MDFlavourisation2,
  MDFlavourisation3,
  MDSimpleGrammar1,
  MDSimpleGrammar2,
  MDSimpleGrammar3,
  MDSimpleGrammar4,
  MDSimpleGrammar5,
  MDSlovianto1,
  MDSlovianto2,
  MDSlovianto3,
  MDPersonalPronouns1,
  MDPersonalPronouns2,
  MDPersonalPronouns3,
  MDPersonalPronouns4,
  MDPersonalPronouns5,
  MDPersonalPronouns6,
  MDPersonalPronouns7,
  MDNumbers1,
  MDOrthography1,
  MDOrthography2,
  MDOrthography3,
  MDOrthography4,
  Transliterator,
  TransliteratorElement,
};
